<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg style="width: 20px;height: 20px;margin-left: 5px;position: relative;top: 5px;" t="1772029279407" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4912" width="200" height="200"><path d="M512 1.024a510.890667 510.890667 0 1 0 0 1021.866667A510.890667 510.890667 0 0 0 512 1.024z m390.314667 340.650667c22.784 52.138667 35.498667 109.738667 35.498666 170.325333s-12.714667 118.186667-35.498666 170.325333h-192c9.386667-52.821333 14.506667-110.250667 14.506666-170.325333s-5.12-117.504-14.506666-170.325333h192zM384.341333 512c0-61.184 4.693333-119.04 13.226667-170.325333H626.346667c8.533333 51.285333 13.312 109.141333 13.312 170.325333 0 61.184-4.778667 119.04-13.312 170.325333H397.653333c-8.533333-51.285333-13.312-109.141333-13.312-170.325333z m468.309334-255.488h-162.133334c-19.797333-66.474667-46.933333-121.173333-78.933333-158.549333a426.069333 426.069333 0 0 1 241.066667 158.549333zM512 128.853333c37.802667 0 71.850667 49.408 95.232 127.744H416.768C440.149333 178.176 474.197333 128.853333 512 128.853333z m-99.584-30.805333c-32 37.290667-59.136 92.16-78.848 158.549333h-162.133333a426.069333 426.069333 0 0 1 240.981333-158.549333zM121.685333 341.674667h192c-9.386667 52.821333-14.506667 110.250667-14.506666 170.325333s5.12 117.504 14.506666 170.325333h-192A424.277333 424.277333 0 0 1 86.186667 512c0-60.586667 12.714667-118.186667 35.498666-170.325333z m49.664 425.813333h162.133334c19.797333 66.474667 46.933333 121.173333 78.933333 158.549333a426.069333 426.069333 0 0 1-241.066667-158.549333zM512 895.146667c-37.802667 0-71.850667-49.408-95.232-127.744h190.464C583.68 845.824 549.802667 895.146667 512 895.146667z m99.584 30.805333c32-37.290667 59.136-92.16 78.848-158.549333h162.133333a426.069333 426.069333 0 0 1-240.981333 158.549333z" fill="#ffffff" p-id="4913" /></svg>
      <span style="font-size: 14px;margin-left: 5px;color: white;">{{ langMap[language] }}</span>
      <i class="el-icon-arrow-down" style="color: white;font-size: 12px;margin-left: 3px;" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文</el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
      <el-dropdown-item :disabled="language==='fr'" command="fr">Français</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LangSelect',
  data() {
    return {
      langMap: {
        zh: '中文',
        en: 'English',
        fr: 'Français'
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    ...mapState({
      language: state => state.app.language
    })
  },
  methods: {
    async handleSetLanguage(lang) {
      // 将命令转换为简写格式（zh, en, fr）
      const langMap = {
        'zh_CN': 'zh',
        'en_us': 'en',
        'fr_FR': 'fr'
      }
      const shortLang = langMap[lang] || lang
      // 先调用 store 的 action，它会等待 i18n 更新完成
      await this.$store.dispatch('app/setLanguage', shortLang)
      // store action 完成后，i18n 已经更新好了，直接设置 locale
      this.$i18n.locale = shortLang
      console.log(`[LangSelect] Language set to ${shortLang}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.international {
  cursor: pointer;
}
</style>
